import { useEffect } from 'react'

import Loader from '@/components/Loader'

import { useInvestDataState } from './_investDataState'
import { getBrightspotUrl, getInvestmentOpportunityUrl } from '../shared/_api'

const DealRedirect = () => {
  const { data: investData } = useInvestDataState()
  const drupalId = investData?.opportunity?.drupal_id

  useEffect(() => {
    if (!drupalId) {
      return
    }

    window.location.assign(getInvestmentOpportunityUrl(drupalId))
  }, [drupalId])

  if (!drupalId) {
    return (
      <div className="p-6 xl:p-[60px] h-[60vh] w-full xl:max-w-[1000px] text-content-black">
        <div className="text-[24px] mb-6 font-bold">
          Investment opportunity not found
        </div>
        <p className="mb-6">
          We couldn&apos;t find the public deal page for this investment.
        </p>
        <a
          href={getBrightspotUrl()}
          className="flex items-center h-10 w-full md:w-fit justify-center rounded px-4 bg-primary text-16 font-medium hover:bg-primary-hover border-bg-primary text-[#F2F2F2] md:min-w-[200px]"
        >
          Back to Homepage
        </a>
      </div>
    )
  }

  return (
    <div className="flex h-[60vh] w-full flex-col items-center justify-center gap-4 text-content-black">
      <Loader />
      <p>Redirecting to the investment opportunity...</p>
    </div>
  )
}

export default DealRedirect
